import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { Methods } from '../Methods'
import { Total } from '../../styles'

export default function Totals({ payment }) {
  return (
    <div>
      <Total>
        <div>SUB TOTAL</div>
        <div>{currencyFormat(payment.attributes.total_gross)}</div>
      </Total>
      <Total>
        <div>DESCONTOS</div>
        <div>{currencyFormat(payment.attributes.total_discount)}</div>
      </Total>
      <Total>
        <div>TOTAL</div>
        <div>{currencyFormat(payment.attributes.total_net)}</div>
      </Total>

      <Methods paymentMethods={payment.attributes.payment_methods} />

      <Total>
        <div>TROCO</div>
        <div>{currencyFormat(payment.attributes.change_value)}</div>
      </Total>
    </div>
  )
}

Totals.propTypes = {
  payment: PropTypes.objectOf(PropTypes.any).isRequired,
}
